import clsx from 'clsx'
import React from 'react'
import Box from '@mui/material/Box'
import {makeStyles} from 'external/material'
import EditableCaption from '../../components/editable-caption'

const useStyles = makeStyles(unitStyles)

export default function Unit({context, className, onChange}) {

  const classes = useStyles()

  const {translate, quizAssessment: assessment} = context
  const [editingUnit, setEditingUnit] = React.useState(false)
  const unit = assessment.unit || ''

  function onEditUnitClick () {
    setEditingUnit(true)
  }

  function closeEditUnit() {
    setEditingUnit(false)
  }

  async function handleUnitChange(unit) {
    if (assessment.unit != unit) {
      onChange && onChange(unit)
   }
  }

  return (
    <Box className={clsx(classes.root, className)} onClick={onEditUnitClick}>
      <Box className={clsx(classes.label, "label")}>{translate('unit')}:</Box>
      <Box className={clsx(classes.input, "input")}>
        <EditableCaption
          editing={editingUnit}
          value={assessment.unit || ''}
          onCancel={closeEditUnit}
          onConfirm={unit => handleUnitChange(unit) && closeEditUnit()}
          className={classes.unit}
        />
      </Box>
    </Box>
  )
}

function unitStyles(theme) {

  const verticalCentering = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center'
  }

  return {
    root: {
      width: 75,
    },
    unit: {
      flexGrow: 1,
      display: 'flex',
      overflow: 'hidden',
      minHeight: 19
    },
    input: {
      display: 'flex',
      border: 'solid 1px #aab7bf',
      borderRadius: 4,
      cursor: 'text',
      padding: 5,
      '& .control': {
        display: 'flex',
        flexGrow: 1,
      },
      '& .input-wrapper': {
        flexGrow: 1,
        ...verticalCentering
      },
      '& .input': {
        border: 'none',
        width: '100%',
        flexGrow: 1,
        '&:focus': {
          outline: 'none'
        }
      },
      '& .addornment': {
        cursor: 'pointer',
        marginTop: -3,
        ...verticalCentering
        }
    },
  }
}

